<div id="loading" [hidden]="!show">
  <div id="spinner">
      <span class="k-icon k-i-loading" style="font-size: 64px;"></span>
      <p>{{msg}}</p>
  </div>
</div>
